import React from 'react';
import PropTypes from 'prop-types';

const Text = ({
  children,
  tag,
  ...rest
}) => {
  const Component = tag;
  return (
    <Component {...rest}>{children}</Component>
  );
};

Text.propTypes = {
  tag: PropTypes.string,
};

Text.defaultProps = {
  tag: 'p',
};

export default Text;
